module.exports = __webpack_public_path__ + "static/media/t2.9423e47b.svg";